import { DataAttributeDefinitions } from 'scrivito'

import { pisaTimerecordUtilizationDataClass } from './Pisa/pisaTimerecordUtilizationDataClass'

const attributes: DataAttributeDefinitions = {}

export const TimerecordUtilization =
  pisaTimerecordUtilizationDataClass(attributes)
